var render = function render(_c,_vm){return _c('div',[(_vm.props.column === 'ObjectiveCombinedId')?_c('el-tag',{class:{
      Strategyc: _vm.$options.isStrategic(_vm.props),
      Operational: _vm.$options.isOperational(_vm.props),
      blink:
        _vm.$options.NoTasks(_vm.props) ||
        (_vm.props.row.ExecutionPercentage < 100
          ? _vm.$options.outdated(_vm.props, _vm.$options.actualDate)
          : false),
      outdated:
        _vm.props.row.ExecutionPercentage < 100
          ? _vm.$options.outdated(_vm.props, _vm.$options.actualDate)
          : false,
      closedInTime: _vm.props.row.ExecutionPercentage === 100
    }},[_vm._v(_vm._s(_vm.props.rowValue))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }